import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Comment } from '../models/comment.model';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(private httpClient: HttpClient) { }

  getComments(productId: string): Observable<Comment[]> {
    const host = environment.host;
    return this.httpClient.get<Comment[]>(host + '/comments/product/' + productId);
  }

  postComment(productId: string, text: string): Observable<Comment> {
    const host = environment.host;
    return this.httpClient.post<Comment>(host + '/comments', { productId, text });
  }

  updateComment(commentId: string, text: string): Observable<Comment> {
    const host = environment.host;
    return this.httpClient.put<Comment>(host + '/comments/' + commentId, { text });
  }

  deleteComment(commentId: string): Observable<{ deleted: boolean; _id: string }> {
    const host = environment.host;
    return this.httpClient.delete<{ deleted: boolean; _id: string }>(host + '/comments/' + commentId);
  }
}
